<template>
    <b-modal
        :id="modalId"
        size="xl"
        hide-footer
        body-class="overflow-auto height-min-400"
        centered
        :title="$t('availability')"
        @hidden="handleHidden()"
    >
        <EChart :options="chartData" card class="shadow-none m-0">
            <template #nav>
                <div :key="spaceId" class="d-flex gap-3">
                    <MultiselectAvailableCampaigns
                        :allow-empty="false"
                        :value="campaigns"
                        @change="campaigns = $event"
                    />
                </div>
            </template>
        </EChart>
    </b-modal>
</template>



<script>
    import EChart from '@/components/common/EChart.vue';
    import MultiselectAvailableCampaigns from '@/components/common/MultiselectAvailableCampaigns.vue';

    export default {
        name: 'ModalAvailabilityInStoresItem',
        components: {
            EChart,
            MultiselectAvailableCampaigns,
        },
        data() {
            return {
                modalId: 'ModalAvailabilityInStoresItem',
                item: null,
                defaultCampaigns: [],
                campaigns: [],
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            chartData() {
                const perShop = this.item?.allPriceOccurrences;
                if (!perShop || Object.keys(perShop).length === 0) {
                    return { series: [] };
                }

                const shopLabels = this.campaigns.map(item => item.name);

                const apexData = shopLabels.map(shopName => {
                    const segments = (perShop[shopName] || [])
                        .map(seg => {
                            const startTs = Number(seg?.start);
                            const endTs = Number(seg?.end);
                            if (!Number.isFinite(startTs) || !Number.isFinite(endTs) || startTs > endTs) return null;
                            return { x: shopName, y: [startTs, endTs] };
                        })
                        .filter(Boolean);

                    return { name: shopName, data: segments };
                });

                const series = apexData.map(row => ({
                    name: row.name,
                    type: 'rangeBar',
                    data: [row],
                }));

                return {
                    xAxis: { type: 'time' },
                    yAxis: {
                        type: 'category',
                        data: shopLabels,
                    },
                    series,
                };
            },
        },
        methods: {
            initItem(item) {
                this.item = item;
            },
            handleHidden() {
                this.item = null;
                this.campaigns = [];
            },
        },
        mounted() {
            this.$root.$on(this.modalId, this.initItem);
        },
        beforeDestroy() {
            this.$root.$off(this.modalId, this.initItem);
        },
    };
</script>
